import React, { useEffect, useState } from 'react';
import { Button, Col, Form, message, Modal, Row, Skeleton } from 'antd';

import FormInput from 'components/FormInput/FormInput';
import FormSelection from 'components/FormSelection/FormSelection';

const { useForm } = Form;
const { confirm } = Modal;

const AddBenefitModal = ({ defaultValues = {}, isLoading, onOk, onClose, onRemove, title, typeLabel, types, visible }) => {
  const [form] = useForm();
  const [selectedType, setSelectedType] = useState('');
  const isWaiverType = selectedType === 'tpdWaiver' || selectedType === 'ciWaiver';
  const isOtherBenefits = selectedType === 'otherBenefit';

  useEffect(() => {
    if (defaultValues.type) {
      setSelectedType(defaultValues.type);
    }
    if (!defaultValues) {
      form.setFieldsValue({
        type: undefined
      });
    }
  }, [defaultValues, form]);

  const handleOnOkButtonClick = async e => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach(field => message.error(field.errors[0]));
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: 'Do you want to remove this from the list?',
      okText: 'Yes',
      onOk() {
        onRemove();
      },
      onClose() {}
    });
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          Remove
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          Save this coverage
        </Button>
      ]
    : [
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          Add new coverage
        </Button>
      ];

  return (
    <Modal title={title} visible={visible} onOk={handleOnOkButtonClick} onCancel={onClose} footer={footer} width="60%">
      <Form form={form} initialValues={defaultValues}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Row gutter={16}>
              <Col span={12}>
                <FormSelection
                  label={typeLabel || 'Type'}
                  name="type"
                  placeholder="Select a type"
                  requiredErrorMessage="Please select a type for this benefit."
                  selections={types}
                  extraProps={{
                    onChange: value => setSelectedType(value)
                  }}
                />
              </Col>
              {!isWaiverType && (
                <Col span={12}>
                  <FormInput label="Coverage Amount" name="amount" placeholder="0.00" type="financial" requiredErrorMessage="Please enter amount of this benefit." />
                </Col>
              )}
              {isOtherBenefits && (
                <Col span={24}>
                  <FormInput label="Label" name="label" placeholder="Enter a label for this benefit" requiredErrorMessage="Please enter label for this benefit." />
                </Col>
              )}
              <Col span={24}>
                <FormInput label="Remarks" name="remarks" placeholder="Leave a remarks" type="textArea" />
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default AddBenefitModal;
